import { HydratedNextGenZapAsset } from "@zapier/client";
import { useTranslations } from "@zapier/i18n";
import AssetRow from "./AssetRow";

interface Props {
  nextGenZap: HydratedNextGenZapAsset;
  folderId?: string;
  /** Whether the surrounding table shows checkboxes, and so needs the column reserved. */
  includeSelectionColumn?: boolean;
  showLastRun?: boolean;
  showLocationColumn?: boolean;
}

/** Read-only row for a Next Gen Zap: opens its editor, offers no actions and is never selectable. */
export function AssetRowNextGenZap({
  nextGenZap,
  folderId,
  includeSelectionColumn,
  showLastRun,
  showLocationColumn,
}: Props) {
  const tAssetTypes = useTranslations("asset-types");
  const tFallbacks = useTranslations("fallbacks");
  const typeLabel = tAssetTypes("singular.nextGenZap");

  return (
    <AssetRow
      allowSelection={false}
      appIds={nextGenZap.displayApps.map(
        ({ implementationName }) => implementationName,
      )}
      asset={nextGenZap}
      assetTypeLabel={typeLabel}
      folderId={folderId}
      folderZapTableRow={true}
      hiddenSelection={!!includeSelectionColumn}
      isUntitled={!nextGenZap.name}
      showFavoriteButton={false}
      showLastRun={showLastRun}
      showLocationColumn={showLocationColumn}
      title={
        nextGenZap.name ||
        tFallbacks("untitled-asset", { assetType: typeLabel })
      }
      updatedAt={new Date(nextGenZap.updatedAt)}
      url={nextGenZap.editorUrl}
    />
  );
}
